import { Tooltip } from 'bootstrap';

export default {
  beforeMount(el, binding) {
    // Ensure the title is provided
    if (binding.value) {
      el._tooltip = new Tooltip(el, {
        title: binding.value,
        placement: binding.arg || 'top', // Default placement is 'top'
      });
    } else {
      console.error('Tooltip title is not provided');
    }
  },
  unmounted(el) {
    if (el._tooltip) {
      el._tooltip.dispose();
    }
  }
};
